export default __webpack_public_path__ + "static/media/ryonet-logo.0b5ab52d.png";